// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__Rp35z","floating":"header_floating__KhlYu","logo":"header_logo__0hp8p","transparent":"header_transparent__TuUTV"};